<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: "App"
  };

</script>

<style>
#app{
  /* font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; */
  color: #000;
  height: 100%;
  width: 100%;
  font-size: 62.5%;
}
/* @media only screen and (min-width: 374px) {
  html .MediaTest{
    font-size: 60.5% !important;
  }
}
@media only screen and (min-width: 414px) {
  html .MediaTest{
    font-size: 62.5% !important;
  }
}
@media only screen and (min-width: 480px) {
  html .MediaTest{
    font-size: 92.5% !important;
  }
}
html .MediaTest{
  font-size: 62.5%;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue